import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./InputLabel.module.scss";
export const InputLabel = ({ htmlFor, id, children, labelId }) => {
    return (_jsx("label", { htmlFor: htmlFor, id: labelId || id, className: classNames(styles.label, styles.topLabel), children: children }));
};
//# sourceMappingURL=InputLabel.js.map